// Small navigation / error helpers shared by ProductPage.tsx and the sub-components
// split out of it (SRP) - kept in a neutral module (same pattern as constants.ts) so
// those components don't import from the page file itself.
import { ApiError } from '@/api/errors';
import { getT } from '@/i18n';
import { sectionRouter } from '@/utils/navigateMain';
import { setUnsavedDirty } from '@/utils/unsavedChanges';
import { f7 } from 'framework7-react';

export function fail(e: unknown) {
  if (e instanceof ApiError) return;
  f7.dialog.alert(e instanceof Error ? e.message : getT().error);
}

// Menu lives in the main view on desktop but the Settings tab (a separate View)
// on mobile - sectionRouter picks the right one so navigation works on both.
export const router = () => sectionRouter();

// Navigate back after a successful save (or a delete/clear): the form's draft is
// gone-for-good on purpose, so clear the unsaved-changes flag first - otherwise
// the route's leave-guard (see MENU_EDIT_GUARD_PATHS in routes.ts) would prompt
// "Discard changes?" on our own Save.
export const leaveBack = () => {
  setUnsavedDirty(false);
  router()?.back();
};
